<template>
  <div>
    <h4 class="text-center mb-5">Onboarding Home</h4>
    <!-- Desktop and large device text -->
    <div class="desktop-text">
      <p>Welcome to the Trailfinders Onboarding Portal. Congratulations on your successful application. Please click on the link below to view the offer letter from Trailfinders.</p>
      <a target="_blank" :href="`${fileURL}/applicant/${email}/files/offer-letter/${filename}`">{{ filename }}</a>
      <p class="mt-3">If you are happy with the offer, please read the guidance below and complete the onboarding documentation.</p>
      <ul>
        <li v-for="(text, index) in instructionsDesk" :key="'desktop-instruction-' + index">{{ text }}</li>
      </ul>
    </div>
    <!-- Mobile and small device text -->
    <div class="mobile-text">
      <p>Welcome to the Trailfinders Application Portal. Thank you for registering. Please ensure you read through the guidance below.</p>
      <ul>
        <li v-for="(text, index) in instructionsMobile" :key="'mobile-instruction-' + index">{{ text }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
const { VUE_APP_RECRUITMENT_API } = process.env
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
    }),
  },
  mounted () {
    setTimeout(() => {
      this.email = this.getRecruit.email ?  this.getRecruit.email : ''
      this.filename = this.getRecruit.onboarding.offerLetter ? this.getRecruit.onboarding.offerLetter.filename : ''
    }, 100)
  },
  data () {
    return {
      email: '',
      filename: '',
      fileURL: VUE_APP_RECRUITMENT_API,
      instructionsDesk: [
        'Please complete each section of the form using the menu on the left.',
        'The FAQ\'s, Corporate Gear and Preparing for Induction sections require you to confirm that you have read the document by clicking the checkbox at the bottom of the page',
        'You can save your progress and logout, then return later if required',
        'You will find the save button on the menu on the left and at the bottom of each section',
        'Please check all your details carefully and press Submit Application once complete',
        'Once you have submitted your onboarding documents, you will be unable to make changes. You will still be able to access your Offer Letter and any information relating to preparing for induction.'
      ],
      instructionsMobile: [
        'Please complete each section of the form by clicking on the icons at the top',
        'The FAQ\'s, Corporate Gear and Preparing for Induction sections require you to confirm that you have read the document by clicking the checkbox at the bottom of the page',
        'You can save your progress and logout, then return later if required',
        'You will find the save button on the menu bar at the top of each section and under the content of each section',
        'Please check all your details carefully and press Submit Application once complete',
        'Once you have submitted your onboarding documents, you will be unable to make changes. You will still be able to access your Offer Letter and any information relating to preparing for induction.'
      ]
    }
  },
  watch: {
    'getRecruit.onboarding.offerLetter': function (){
      this.filename = this.getRecruit.onboarding.offerLetter.filename
    }
  }
}
</script>

<style scoped>

</style>